v-row
  v-col(cols="12")
    v-row
      v-col(cols="12" md="8")
        v-text-field(:label="name_label" v-model="_name" :rules="name_rules")
      v-col(cols="12" md="4")
        DateInput(:label="date_label" v-model="_date" :rules="date_rules")
    v-row
      v-col(cols="12")
        SignaturePad(:label="signature_label" v-model="_signature" :rules="signature_rules")
